<p><a href="https://calmray.com" alt="Calm Ray" title="Calm Ray"><img src="assets/main/cr-logo.png" alt="Calm Ray Logo" title="Calm Ray"/></a></p>
<div>
    <p>&copy; Baltic Exchange {{ now | date:'yyyy' }}</p>
    <p>Version: {{ version }}</p>
    <p>Version released on: {{ versionReleaseDate | date: 'EEEE dd MMM yyyy' }}</p>
    <p>Environment: {{ environmentName }}</p>
</div>